import gsap from 'gsap';
import SplitText from '../../../../js/vendors/gsap/SplitText';

gsap.registerPlugin(SplitText);

export class IntroComponent {
    constructor(container) {
        this.element = container.querySelector('[data-component-intro]');
        if (!this.element) return;

        this.eyebrow = this.element.querySelector('.gom-eyebrow');
        this.title = this.element.querySelector('h1');
        this.stamp = this.element.querySelector('.gom-stamp');
        this.statsList = [...this.element.querySelectorAll('.right dl')];

        this.init();
    }

    init() {
        if (!this.element) return;
        this.initText();
        this.animate();
    }

    initText() {
        if (this.title) {
            this.titleSplit = new SplitText(this.title, {
                types: 'lines,words,chars',
                charsClass: 'js-letter'
            });

            this.titleChars = this.titleSplit.chars;

            this.titleChars.forEach((char) => {
                char.innerHTML = '<div class="js-inner">' + char.innerHTML + '</div>';
            });

            this.titleCharsInner = [...this.title.querySelectorAll('.js-inner')];

            gsap.set(this.titleCharsInner, {
                y: '100%'
            });
        }

        if (this.eyebrow) {
            this.eyebrowSplit = new SplitText(this.eyebrow, {
                types: 'words',
                wordsClass: 'js-word'
            });

            this.eyebrowWords = this.eyebrowSplit.words;

            this.eyebrowWords.forEach((word) => {
                word.innerHTML = '<div class="js-inner">' + word.innerHTML + '</div>';
            });

            this.eyebrowWordsInner = [...this.eyebrow.querySelectorAll('.js-inner')];

            gsap.set(this.eyebrowWordsInner, {
                y: '100%'
            });
        }

        if (this.stamp) {
            gsap.set(this.stamp, {
                scale: 0,
                opacity: 0,
                rotation: -15
            });
        }

        if (this.statsList.length) {
            gsap.set(this.statsList, {
                x: -50,
                opacity: 0
            });
        }

        this.element.classList.add('initialized');
    }

    animate() {
        const timeline = gsap.timeline();

        if (this.titleCharsInner) {
            timeline.to(this.titleCharsInner, {
                y: 0,
                duration: 0.8,
                stagger: {
                    amount: 0.5
                },
                ease: 'power2.out',
            }, 0);
        }

        if (this.eyebrowWordsInner) {
            timeline.to(this.eyebrowWordsInner, {
                y: 0,
                duration: 0.6,
                stagger: {
                    amount: 0.3
                },
                ease: 'power2.out',
            }, .5);
        }

        if (this.stamp) {
            timeline.to(this.stamp, {
                scale: 1,
                opacity: 1,
                rotation: 3,
                duration: 0.6,
                ease: 'back.out(1.7)',
            }, 1);
        }

        if (this.statsList.length) {
            timeline.to(this.statsList, {
                x: 0,
                opacity: 1,
                duration: 0.8,
                stagger: {
                    amount: 0.3,
                    from: "start"
                },
                ease: "power2.out"
            }, 0.8);
        }
    }

    dispose() {
        if (this.titleCharsInner) {
            gsap.killTweensOf(this.titleCharsInner);
        }
        if (this.eyebrowWordsInner) {
            gsap.killTweensOf(this.eyebrowWordsInner);
        }
        if (this.stamp) {
            gsap.killTweensOf(this.stamp);
        }
        if (this.statsList.length) {
            gsap.killTweensOf(this.statsList);
        }

        // Clear references
        this.element = null;
        this.eyebrow = null;
        this.title = null;
        this.titleCharsInner = null;
        this.eyebrowWordsInner = null;
        this.stamp = null;
        this.statsList = null;
    }
}
